import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import {fontSize, formatBlock, blockquote, fontColor, align, list, table, link, image} from 'suneditor/src/plugins'

const SUNEDITOR_LANGS = ['ckb','cs','da','de','en','es','fa','fr','he','hu','it','ja','km','ko','lv','nl','pl','pt_br','ro','ru','se','tr','ua','ur','zh_cn']

const getSunEditorLang = (lang) => SUNEDITOR_LANGS.includes(lang) ? lang : 'en'

const HtmlEditor = (props) => {

  const onChange = (newVal) => {
    props.handleTextChange({target: {value: newVal}})
  }

  const field = props.data
  const options = {
     plugins: [fontSize, formatBlock, blockquote, fontColor, align, list, table, link, image], 
     buttonList: [['undo', 'redo'], ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'blockquote', 'fontColor', 'removeFormat'], ['fontSize', 'formatBlock'],
                  ['align', 'list'], ['table', 'link', 'image'], ['fullScreen', 'showBlocks', 'codeView', 'print']]
  }
  let height =  MC.getFieldParamValue(field.param, '@height') ?? '500px'
  
  return  <SunEditor width="100%" height={height + 'px'} placeholder={props.placeholder} lang={getSunEditorLang(field.flow.reactFlow().props.mconf.lang)} name={props.data.id} onChange={onChange} setContents={props.value}
            disable={props.disabled} readOnly={props.readOnly} setOptions={options}/>

}

MC.registerReactRomponent('htmleditor', HtmlEditor)